module.exports = __webpack_public_path__ + "img/Fill.9b7461be.svg";